var acc = document.getElementsByClassName('js-accordion');
var i;

for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener('click', function () {
        this.classList.toggle('active');
        var panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
            panel.style.display = 'none';
        } else {
            panel.style.display = 'block';
        }
    });
}

const dropdown = document.querySelector('.location-actions.has-dropdown');

if (dropdown) {
    const dropdownItems = dropdown.querySelectorAll('.location-item');
    const locationDetail = document.querySelector('.location-details');

    // Add a click event listener to the dropdown header
    dropdown.querySelector('.heading-h6').addEventListener('click', function () {
        dropdown.classList.toggle('open');
    });

    // Add click event listeners to the dropdown items
    dropdownItems.forEach(function (item) {
        item.addEventListener('click', function () {
            const selectedValue = item.getAttribute('data-value');

            // Hide all location divs
            locationDetail.querySelectorAll('.location').forEach(function (location) {
                location.classList.add('hidden');
            });

            // Show the location div corresponding to the selected item
            const selectedLocation = document.getElementById(selectedValue + 'location');
            if (selectedLocation) {
                selectedLocation.classList.remove('hidden');
            }

            // Update the dropdown text
            dropdown.querySelector('.heading-h6').textContent = item.textContent;

            dropdownItems.forEach(function (item) {
                if (item.classList.contains('selected')) {
                    item.classList.remove('selected');
                }
            });

            // Update the new dropdown list
            item.classList.add('selected');

            // Close the dropdown
            dropdown.classList.remove('open');
        });
    });
}

var headerHeight = document.querySelector('.header').clientHeight;
var stickyScrollElement = document.querySelector('.sticky-scroll');

export function stickyScroll() {
    if (stickyScrollElement) {
        if (window.scrollY >= headerHeight) {
            stickyScrollElement.classList.add('show');
        } else {
            stickyScrollElement.classList.remove('show');
        }
    }
};

if (stickyScrollElement) {
    stickyScrollElement.addEventListener('click', function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}
